import { CookiesService } from '@services/cookies/cookies.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

const defaultLanguage = 'en';
/*
 * Will set the language to the user language if available, otherwise to the browser or default language
 */
export function translationInitializerFactory(cookiesService: CookiesService, translate: TranslateService) {
    return (): Promise<any> => {
        return firstValueFrom(translate.use(defaultLanguage));
    };
}
